import { createSlice } from "@reduxjs/toolkit";
import {
  getAdminDashboard, getAdminEmailRecipients,
  getAdminBusinessOverview, getAdminBusinessUsers, getAdminUsers, getBlogItems, getBusinessDashboard, getSentEmails, getTopUpActivity, getTopUpIndex
} from "../actions/adminActions";



const initialAdminState = {
  adminsdata: {types:[],filters:{
      subjectFilter:"",typeFilter:"",yearFilter:"",
      loading:false,
      stats: {},
      usersMeta: {},
      users: [],
    },
    emailGroups: [
      {id: 1,name: "Activated users"},
      {id: 2,name: "Registered users"},
      {id: 3,name: "Registered but not practiced"},
      {id: 4,name: "Registered and practiced"},
    ],
    businesses: [],
    businessesMeta: {},
    businessOverviewStats: {},
    businessUsers: [],
    businessUsersMeta: {},
    selectedBusinessId: null,
    businessesLoading: false,
    businessUsersLoading: false,
    emailRecipients: [],
    emailRecipientsLoading: false,
  },
  businessdata: {types:[],filters:{
      subjectFilter:"",typeFilter:"",yearFilter:"",
      loading:false,
      isInviteModal:false,
      inviteUrl:false,
      stats: {},
      usersMeta: {},
      users: [],
    },
    learners: [],
  },
  blogsdata: {
    blog: null,
    blogs: null,
  },
  headerData: {
    isSubscribeModal:false
  }

};

const adminSlice = createSlice({
  name: "admin",
  initialState: initialAdminState,
  reducers: {
    setGlobalUserFilter(state, action) {
      localStorage.setItem(`filterUsers`, JSON.stringify({...action.payload}));
    },
    setGlobalAnalysisFilter(state, action) {
      localStorage.setItem(`analysisFilters`, JSON.stringify({...action.payload}));
    },
    setGlobalAllAnalysisFilter(state, action) {
      localStorage.setItem(`allAnalysisFilters`, JSON.stringify({...action.payload}));
    },
    setGlobalFlaggedFilter(state, action) {
      localStorage.setItem(`flaggedFilters`, JSON.stringify({...action.payload}));
    },
    setGlobalEmailFilter(state, action) {
      localStorage.setItem(`emailFilters`, JSON.stringify({...action.payload}));
    },
    setGlobalEmailAnalysisFilter(state, action) {
      localStorage.setItem(`emailAnalysisFilters`, JSON.stringify({...action.payload}));
    },
    toggleInviteModal(state, action) {
      state.businessdata.isInviteModal = action.payload.action;
    },
    toggleSubscribeModal(state, action) {
      state.headerData.isSubscribeModal = action.payload.action;
    },
    toggleRecipientType(state, action) {
      state.businessdata.learners =  state.adminsdata.emailGroups;
      // console.log("dispatched Called",state.businessdata.learners);
    },
    refreshExamTabTable(state, action) {
      state.adminsdata.loadingMail = true;
      state.adminsdata.loadingMail = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAdminUsers.pending, (state) => {
      state.adminsdata.loading = true;
    });
    builder.addCase(getAdminUsers.rejected, (state,action) => {
      state.adminsdata.error = action.payload;
    });
    builder.addCase(getAdminUsers.fulfilled, (state, action) => {
      state.adminsdata.users = action.payload.payload;
      state.adminsdata.usersMeta = action.payload.meta;
      state.adminsdata.loading = false;
    });
    builder.addCase(getAdminEmailRecipients.pending, (state) => {
      state.adminsdata.emailRecipientsLoading = true;
      state.adminsdata.emailRecipientsError = null;
    });
    builder.addCase(getAdminEmailRecipients.rejected, (state, action) => {
      state.adminsdata.emailRecipientsLoading = false;
      state.adminsdata.emailRecipientsError = action.payload;
    });
    builder.addCase(getAdminEmailRecipients.fulfilled, (state, action) => {
      state.adminsdata.emailRecipients = action.payload?.payload || [];
      state.adminsdata.emailRecipientsLoading = false;
    });
    builder.addCase(getAdminDashboard.pending, (state) => {
      state.adminsdata.loading = true;
    });
    builder.addCase(getAdminDashboard.rejected, (state,action) => {
      state.adminsdata.error = action.payload;
    });
    builder.addCase(getAdminDashboard.fulfilled, (state, action) => {
      state.adminsdata.stats = action.payload.stats;
      state.adminsdata.loading = false;
    });

    builder.addCase(getAdminBusinessOverview.pending, (state) => {
      state.adminsdata.businessesLoading = true;
      state.adminsdata.businessesError = null;
    });
    builder.addCase(getAdminBusinessOverview.rejected, (state, action) => {
      state.adminsdata.businessesLoading = false;
      state.adminsdata.businessesError = action.payload;
    });
    builder.addCase(getAdminBusinessOverview.fulfilled, (state, action) => {
      const payload = action.payload || {};
      state.adminsdata.businesses = Array.isArray(payload)
        ? payload
        : payload.businesses || payload.payload || [];
      state.adminsdata.businessesMeta = payload.meta || {};
      state.adminsdata.businessOverviewStats = payload.stats || {};
      state.adminsdata.businessesLoading = false;
    });

    builder.addCase(getAdminBusinessUsers.pending, (state, action) => {
      const isNewBusiness =
        action.meta.arg.businessId !== state.adminsdata.selectedBusinessId;
      if (isNewBusiness) {
        state.adminsdata.businessUsers = [];
        state.adminsdata.businessUsersMeta = {};
      }
      state.adminsdata.businessUsersLoading = true;
      state.adminsdata.businessUsersError = null;
      state.adminsdata.selectedBusinessId = action.meta.arg.businessId;
    });
    builder.addCase(getAdminBusinessUsers.rejected, (state, action) => {
      if (action.meta.arg.businessId !== state.adminsdata.selectedBusinessId) return;
      state.adminsdata.businessUsersLoading = false;
      state.adminsdata.businessUsersError = action.payload;
    });
    builder.addCase(getAdminBusinessUsers.fulfilled, (state, action) => {
      const payload = action.payload || {};
      if (payload.businessId !== state.adminsdata.selectedBusinessId) return;
      state.adminsdata.businessUsers = Array.isArray(payload)
        ? payload
        : payload.users || payload.payload || [];
      state.adminsdata.businessUsersMeta = payload.meta || {};
      state.adminsdata.businessUsersLoading = false;
    });

    builder.addCase(getSentEmails.pending, (state) => {
      state.adminsdata.loadingMail = true;
    });
    builder.addCase(getSentEmails.rejected, (state,action) => {
      state.adminsdata.error = action.payload;
    });
    builder.addCase(getSentEmails.fulfilled, (state, action) => {
      state.adminsdata.sentEmails = action.payload.payload;
      state.adminsdata.meta = action.payload.meta;
      state.adminsdata.loadingMail = false;
    });

    builder.addCase(getBusinessDashboard.pending, (state) => {
      state.businessdata.loading = true;
    });
    builder.addCase(getBusinessDashboard.rejected, (state,action) => {
      state.businessdata.error = action.payload;
    });
    builder.addCase(getBusinessDashboard.fulfilled, (state, action) => {
      state.businessdata.stats = action.payload.stats;
      state.businessdata.inviteUrl = action.payload.inviteUrl;
      state.businessdata.loading = false;
    });

    //TopUp
    builder.addCase(getTopUpIndex.pending, (state) => {
      state.businessdata.loading = true;
    });
    builder.addCase(getTopUpIndex.rejected, (state,action) => {
      state.businessdata.error = action.payload;
    });
    builder.addCase(getTopUpIndex.fulfilled, (state, action) => {
      state.businessdata.learners = action.payload.users;
      state.businessdata.loading = false;
      // console.log(state.businessdata.learners);
    });
    // TopUp Activity
    builder.addCase(getTopUpActivity.pending, (state) => {
      state.businessdata.loadingActivity = true;
    });
    builder.addCase(getTopUpActivity.rejected, (state,action) => {
      state.businessdata.error = action.payload;
    });
    builder.addCase(getTopUpActivity.fulfilled, (state, action) => {
      state.businessdata.activity = action.payload.activity;
      state.businessdata.isTransactionLoaded = true;
      state.businessdata.loadingActivity = false;
      // console.log(state.businessdata.learners);
    });

    // Blogs
    builder.addCase(getBlogItems.pending, (state) => {
      state.blogsdata.loadingBlog = true;
      state.blogsdata.blogs = null;
      state.blogsdata.blog = null;
    });
    builder.addCase(getBlogItems.rejected, (state,action) => {
      state.blogsdata.loadingBlog = false;
    });
    builder.addCase(getBlogItems.fulfilled, (state, action) => {
      if(action.payload.blog){
        state.blogsdata.blog = action.payload.blog;
        state.blogsdata.url = action.payload.url;
      }
      else{
        state.blogsdata.blogs = action.payload.payload;
        state.blogsdata.meta = action.payload.meta;
      }
      state.blogsdata.loadingBlog = false;
      // console.log(state.blogsdata.blogs);
    });

  },
});

export const {
      setUsers,
  setGlobalUserFilter,
  setGlobalAnalysisFilter,
  setGlobalAllAnalysisFilter,
  setGlobalFlaggedFilter,
  setGlobalEmailFilter,
  setGlobalEmailAnalysisFilter,
  toggleInviteModal,
  toggleRecipientType,
  toggleSubscribeModal,
  refreshExamTabTable
} = adminSlice.actions;

export default adminSlice.reducer;
